import LegalLayout, { Sections } from "./LegalLayout";
import { useLegal } from "./content";

export default function Terms() {
  const { terms: p } = useLegal();
  return (
    <LegalLayout testid="terms-page" kicker={p.kicker} title={p.title} intro={p.intro} toc={p.sections}>
      <Sections sections={p.sections} />
    </LegalLayout>
  );
}
